import React from 'react';
import { useWindowSize } from 'hooks/useWindowSize';
import MobileSendToolbar from './MobileSendToolbar';
import DesktopSendToolbar from './DesktopSendToolbar';
import { SendToolbarProps } from './sendToolbarControls';
import './SendPageHeader.css';

const MOBILE_BREAKPOINT = 768;

/**
 * Send Cards page header. Below 768px renders a vertical-stack mobile toolbar;
 * at 768px and above renders a horizontal desktop toolbar with progressive
 * collapse. The two layouts are deliberately separate components — the mobile
 * stack and the desktop overflow-driven toolbar share no flex/wrap logic.
 */
export default function SendPageHeader(props: SendToolbarProps) {
  const { width } = useWindowSize(0);
  const isMobile = (width || 1500) < MOBILE_BREAKPOINT;

  return (
    <div className="send-header-container">
      <div className="send-header-top">
        <div className="send-header-text">
          <h2 className="send-header-title">Available Trades</h2>
          <p className="send-header-subtitle">
            These are cards wanted by community members. Initiate a trade and send cards to earn points equivalent to their value.
          </p>
        </div>
      </div>

      {isMobile ? (
        <MobileSendToolbar {...props} />
      ) : (
        <DesktopSendToolbar {...props} />
      )}
    </div>
  );
}
